import EclipseLanding from "@/components/EclipseLanding";
import { OrganizationJsonLd } from "@/components/JsonLd";
import PageMeta from "@/components/PageMeta";
import { useTranslation } from "react-i18next";

const Index = () => {
  const { i18n } = useTranslation();
  const isDe = i18n.language?.startsWith("de");
  return (
    <>
      <PageMeta
        title={
          isDe
            ? "rawResponse Labs — Wir bauen autonome Unternehmen"
            : "rawResponse Labs — We build autonomous companies"
        }
        description={
          isDe
            ? "Eigene Produkte in Produktion. Dieselbe Architektur für Ihr Unternehmen, auf den Tools, die Sie schon haben."
            : "Our own products in production. The same architecture for your company, on the tools you already use."
        }
      />
      <OrganizationJsonLd />
      <main>
        <EclipseLanding />
      </main>
    </>
  );
};

export default Index;
